import React from 'react';

import { 
    IonContent, 
    IonHeader, 
    IonPage, 
    IonTitle, 
    IonSpinner,
    useIonRouter,
    useIonViewWillEnter
} from '@ionic/react';

import { LoadLanguage } from "../language/Language";
import Vault from '../components/Vault';
import { hideTab } from "../components/Tabs";

import './Main.css'; 

const Loader : React.FC = () => {

    //	Initializing our router
	const router = useIonRouter();

    useIonViewWillEnter(() => {
        checkForKeys();

        hideTab();
    });

    const checkForKeys = async () => {

        // load language first
        await LoadLanguage();

        let v = new Vault();
        await v.read();
        
        if (v.account.id >= 0 && v.account.key != "")
            router.push("/main", "back", "pop");
        else
            router.push("/login", "back", "pop");
    }

    return (
        <IonPage>
            <IonContent>
                <div className="spinnerCenter">
                    <IonSpinner name="crescent" />
                    <div className="ion-padding-top">Please wait...</div>
                </div>
            </IonContent>
            </IonPage>
      );
};

export default Loader;
